import MainLayout from 'layouts/MainLayout';
import AssessmentPage from 'pages/Assessment';
import AssessmentList from 'pages/AssessmentList';
import ConfirmEmail from 'pages/ConfirmEmail';
import ExaminationCheck from 'pages/ExaminationCheck';
import ExaminationReceive from 'pages/ExaminationReceive';
import AuthLayout from 'pages/onboarding/components/AuthLayout';
import LayoutWithBG from 'pages/onboarding/components/LayoutWithBG';
import PublicThemeProvider from 'pages/onboarding/components/PublicThemeProvider';
import ConfirmData from 'pages/onboarding/ConfirmData';
import ExaminationRegisterLayout from 'pages/onboarding/ExaminationRegister/ExaminationRegisterLayout';
import PublicExaminationPage from 'pages/onboarding/ExaminationRegister/PublicExaminationPage';
import LanguageSelect from 'pages/onboarding/LanguageSelect';
import Login from 'pages/onboarding/Login';
import OAuth from 'pages/onboarding/OAuth';
import PasswordReset from 'pages/PasswordReset';
import RegisterByEmail from 'pages/Register';
import Account from 'pages/User';
import { createBrowserRouter, Outlet, replace } from 'react-router-dom';
import ROUTES from './constants/routes';

const router = createBrowserRouter([
  {
    path: ROUTES.LOGIN,
    element: (
      <AuthLayout>
        <Login />
      </AuthLayout>
    ),
  },
  {
    path: ROUTES.REGISTER,
    element: (
      <AuthLayout>
        <RegisterByEmail />
      </AuthLayout>
    ),
  },
  {
    path: ROUTES.PASSWORD_RESET,
    element: (
      <AuthLayout>
        <PasswordReset />
      </AuthLayout>
    ),
  },
  {
    path: `${ROUTES.PUBLIC_EXAMINATION}/:examinationId`,
    element: <PublicExaminationPage />,
  },
  {
    path: '/',
    element: (
      <MainLayout>
        <Outlet />
      </MainLayout>
    ),
    children: [
      {
        index: true,
        loader: async () => replace(ROUTES.ASSESSMENT),
      },
      {
        path: `${ROUTES.EXAMINATION_RECEIVE}/:examinationId`,
        element: <ExaminationReceive />,
      },
      {
        path: ROUTES.CONFIRM_REGISTER,
        element: (
          <PublicThemeProvider>
            <ConfirmEmail />
          </PublicThemeProvider>
        ),
      },
      {
        path: ROUTES.ACCOUNT,
        element: <Account />,
      },
      {
        path: ROUTES.ASSESSMENT,
        children: [
          {
            index: true,
            element: <AssessmentList />,
          },
          {
            path: ':id',
            element: <AssessmentPage />,
          },
        ],
      },
    ],
  },
  {
    path: ROUTES.LANGUAGE_SELECT,
    element: (
      <LayoutWithBG>
        <LanguageSelect />
      </LayoutWithBG>
    ),
  },
  {
    path: ROUTES.CONFIRM_USER_DATA,
    element: (
      <LayoutWithBG>
        <ConfirmData />
      </LayoutWithBG>
    ),
  },
  {
    path: '/',
    element: (
      <ExaminationRegisterLayout>
        <Outlet />
      </ExaminationRegisterLayout>
    ),
    children: [
      {
        path: `${ROUTES.EXAMINATION}/:examinationId`,
        element: <ExaminationCheck />,
      },
      {
        path: ROUTES.OAUTH,
        element: (
          <PublicThemeProvider>
            <OAuth />
          </PublicThemeProvider>
        ),
      },
    ],
  },
]);

export default router;
